module.exports = __webpack_public_path__ + "img/icon-black-Tools.19ac66c6.png";